/* eslint-disable indent */
/* eslint-disable quotes */
import { useEffect, useMemo, useState } from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";

import { useDebounce } from "../../shared/hooks";
import { ContaBancariaService } from "../services/api/cadastros/ContaBancaria";

type TAutoCompleteOption = {
  idconta: string;
  label: string;
};

interface IAutoCompleteContaProps {
  codigoconta?: (novoTextoselect: string | undefined) => void;
  descricao?: (novoTextoselect: string | undefined) => void;
  isExternalLoading?: boolean;
}

export const AutoCompleteContaBancariaListagem: React.FC<
  IAutoCompleteContaProps
> = ({ isExternalLoading = false, codigoconta, descricao }) => {
  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>();

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState("");

  useEffect(() => {
    setIsLoading(true);

    debounce(() => {
      ContaBancariaService.getAllList(busca, selectedId?.toString()).then(
        (result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(
              result.data.map((conta) => ({
                idconta: conta.idconta, // Convert string to number
                label: conta.numeroconta + " - " + conta.titular,
              })),
            );
          }
        },
      );
    });
  }, [busca, selectedId]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find((opcao) => opcao.idconta === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);

  return (
    <Autocomplete
      openText="Abrir"
      closeText="Fechar"
      noOptionsText="Sem opções"
      loadingText="Carregando..."
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => {
        setSelectedId(newValue?.idconta);
        setBusca("");
        descricao?.(newValue?.label);
        codigoconta?.(newValue?.idconta);
      }}
      popupIcon={isLoading ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          label="Conta"
          // error={!!error}
          // helperText={error}
        />
      )}
    />
  );
};
